import { useReactFlow } from '@xyflow/react';
import { useKeyboardShortcut } from '@/features/canvas/engine/hooks/use-keyboard-shortcut';

export function useZoomShortcut() {
  const { fitView, zoomIn, zoomOut, getViewport, setViewport } = useReactFlow();

  useKeyboardShortcut(
    { key: '0', meta: true },
    (e) => {
      e.preventDefault();
      fitView();
    },
  );
  useKeyboardShortcut(
    { key: '1', meta: true },
    (e) => {
      e.preventDefault();
      const { x, y } = getViewport();
      setViewport({ x, y, zoom: 1 }, { duration: 200 });
    },
  );
  useKeyboardShortcut(
    { keys: ['=', '+'], meta: true },
    (e) => {
      e.preventDefault();
      zoomIn();
    },
  );
  useKeyboardShortcut(
    { key: '-', meta: true },
    (e) => {
      e.preventDefault();
      zoomOut();
    },
  );
}
